module.exports = __webpack_public_path__ + "img/30.952e098.webp";